import { clsx } from "@ismael1361/utils";
import styles from "./styles.module.scss";
import Icon from "@mdi/react";
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js";
import { useEffect, useRef } from "react";

interface CarouselProps {
	children?: React.ReactNode;
	className?: string;
	style?: React.CSSProperties;
}

export const Carousel: React.FC<CarouselProps> = ({ children, className, style }) => {
	const main = useRef<HTMLDivElement>(null);
	const prevButton = useRef<HTMLDivElement>(null);
	const nextButton = useRef<HTMLDivElement>(null);
	const container = useRef<HTMLDivElement>(null);

	const updateButtonsVisibility = () => {
		if (!container.current) {
			return;
		}
		const hiddenLeft = container.current.scrollLeft <= 0;
		const hiddenRight = container.current.scrollLeft + container.current.offsetWidth >= container.current.scrollWidth;

		prevButton.current?.classList.toggle(styles.hidden, hiddenLeft);
		nextButton.current?.classList.toggle(styles.hidden, hiddenRight);

		main.current?.classList.toggle(styles.hiddenPrev, hiddenLeft);
		main.current?.classList.toggle(styles.hiddenNext, hiddenRight);
	};

	const moveHandler = (to: number) => () => {
		container.current?.scrollBy({ left: container.current.offsetWidth * to * 0.8, behavior: "smooth" });
	};

	useEffect(() => {
		const evetn = () => updateButtonsVisibility();
		container.current?.addEventListener("scroll", evetn);
		window.addEventListener("resize", evetn);
		updateButtonsVisibility();

		return () => {
			container.current?.removeEventListener("scroll", evetn);
			window.removeEventListener("resize", evetn);
		};
	}, [children]);

	return (
		<div
			className={clsx(styles.carousel, className)}
			style={style}
			ref={main}
		>
			<div
				ref={prevButton}
				className={styles.prevButton}
				onClick={moveHandler(-1)}
			>
				<Icon
					path={mdiChevronLeft}
					size={1}
				/>
			</div>
			<div
				className={styles.container}
				ref={container}
			>
				<div className={styles.content}>{children}</div>
			</div>
			<div
				ref={nextButton}
				className={styles.nextButton}
				onClick={moveHandler(1)}
			>
				<Icon
					path={mdiChevronRight}
					size={1}
				/>
			</div>
		</div>
	);
};
